import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import store from '@/store'
import Company from "@/model/Company";
import {Container} from "typescript-ioc";
import CompanyApi from "@/module/device/CompanyApi";
import CompanyStorage from "@/storage/CompanyStorage";
import ActiveModule from "@/store/module/ActiveModule";

export abstract class CompanyModule implements ActiveModule<Company> {
    abstract active: Company

    abstract activeOrNull: Company | null

    abstract activate(company: Company): Promise<void>

    abstract inactivate(): Promise<void>

    abstract hasActive(): Promise<boolean>

    abstract destroy(): Promise<void>
}

@Module({dynamic: true, store, namespaced: true, name: 'company'})
class CompanyModuleImpl extends VuexModule implements CompanyModule {

    private companyApi = Container.get(CompanyApi)

    private companyStorage = Container.get(CompanyStorage)

    activeOrNull = this.companyStorage.getOrNull()

    get active() {
        return this.activeOrNull ?? new Company()
    }

    @Action
    async hasActiveCompany(): Promise<boolean> {
        return this.activeOrNull != null
    }

    @Action
    async activate(company: Company) {
        this.set(company)
        this.companyStorage.set(company)
    }

    @Action
    async inactivate() {
        this.remove()
        this.companyStorage.remove()
    }

    @Action
    async hasActive(): Promise<boolean> {
        return this.activeOrNull != null
    }

    @Action
    async destroy() {
        this.inactivate()
    }

    @Mutation
    private set(company: Company) {
        this.activeOrNull = company
    }

    @Mutation
    private remove() {
        this.activeOrNull = null
    }
}

const companyModule: CompanyModule = getModule(CompanyModuleImpl)
export default companyModule
